angular.module("ticketco/ticketbuyer/orders", [
  "ticketco/ticketbuyer/common",
  "ticketco/ticketbuyer/gift_cards",
  "ticketco/ticketbuyer/signature",
]);